import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ConfirmModal } from '@/components/modules/Modal/ConfirmModal';
import { SmallTagRounded } from '@/components/ui/Tag/SmallTagRounded';
import { LinkText } from '@/components/ui/Typography/Body/LinkText';
import { Text } from '@/components/ui/Typography/Body/Text';
import { useBoolState } from '@/hooks/state/useBoolState';
const config = {
    confirmDetail: {
        label: '詳細確認中',
        tagColor: 'lightBlue',
    },
    interviewDecline: {
        label: '見送り',
        tagColor: 'gray',
    },
    interviewOrder: {
        label: '発注',
        tagColor: 'lightOrange',
    },
    offered: {
        label: '提案',
        tagColor: 'lightOrange',
    },
    proposalDoing: {
        label: '提案検討中',
        tagColor: 'lightOrange',
    },
    proposalRefuse: {
        label: '提案辞退',
        tagColor: 'gray',
    },
    proposalToDo: {
        label: '提案予定',
        tagColor: 'lightOrange',
    },
    statusDisapproved: {
        label: '閲覧拒否',
        tagColor: 'allGray',
    },
};
export const RfpViewRequestStatus = (props) => {
    const { className = '', proposalRefuseReason = '', status } = props;
    const { boolState: isShowModal, changeFalse: hideModal, changeTrue: showModal, } = useBoolState();
    return (_jsxs("div", Object.assign({ className: clsx('inline-flex flex-col items-center', className) }, { children: [_jsx(SmallTagRounded, Object.assign({ color: config[status].tagColor, size: 'xs' }, { children: config[status].label })), proposalRefuseReason && status === 'proposalRefuse' && (_jsxs(_Fragment, { children: [_jsx("button", Object.assign({ className: clsx('group'), onClick: showModal, type: 'button' }, { children: _jsx(LinkText, Object.assign({ isGroup: true, size: 'xs' }, { children: "\u8F9E\u9000\u7406\u7531\u3092\u78BA\u8A8D" })) })), _jsx(ConfirmModal, Object.assign({ headText: '辞退理由', hideModal: hideModal, isShow: isShowModal }, { children: _jsx(Text, Object.assign({ className: 'text-center', color: 'base', size: 'sm' }, { children: _jsx("span", Object.assign({ className: 'inline-block text-left' }, { children: proposalRefuseReason })) })) }))] }))] })));
};
export const rfpViewRequestStatusConfig = config;
